import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ElectricalServices = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13h3v2h-3zm-6-1v2h-2v4h2v2h5v-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11h7V4H4v2h6v3H3v8h6v-2H5zm13 6h3v2h-3z"
  }));
});
ElectricalServices.displayName = 'ElectricalServices';
export var ElectricalServicesDimensions = {
  height: 24,
  width: 24
};